import React from 'react';
import { useState, useEffect, useContext} from "react";
import { Box, IconButton, MenuItem, Select, Modal, CardHeader, Chip } from "@mui/material";
import { ColorModeContext, useMode} from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { fetchToken, fetchRole } from '../auth/Token';
import { Button, CircularProgress } from '@mui/material';
import { api } from '../api';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import LoginIcon from '@mui/icons-material/Login';
import Typography from '@mui/material/Typography';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import  Grid  from '@mui/material/Grid';
import AuthContext from "../auth/AuthProvider";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Backdrop from '@mui/material/Backdrop';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { toast } from 'sonner';


const Season = () => {
    const location = useLocation();
    const society = location.state && location.state.name;
    const society_id = location.state && location.state.society_id;
    const [seasons, setSeasons] = useState([])
    const [open_modal, setOpen_modal] = useState(false)
    const [big_loading, setBig_loading] = useState(false)
    const [season_id, setSeason_id] = useState(null)

    const fetch_seasons = () => {
        setBig_loading(true)
        api.get(`/account/all/society/seasons/${society_id}`,{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
        }).then(function (response){
            setSeasons(response.data?.data);
        }).finally(function () {
            setBig_loading(false)
        })
    }

    const NewSeason = () => {
        setOpen_modal(true)
    }

    const handleCloseSetup = () => {
        setOpen_modal(false);
        setSeason_id(null);
        formik.handleReset()
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 900,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '7px',
        boxShadow: 24,
        p: 4,
      };

      const UpdateSeason = (start_date, end_date, season_name, id) => {
          setSeason_id(id);
          formik.setFieldValue('season_start', start_date)
          formik.setFieldValue('season_end', end_date)
          formik.setFieldValue('season_name', season_name)
          setOpen_modal(true)
      }

      const formik = useFormik({
        initialValues: {
            "season_start": '',
            "season_end": '',
            "season_name": '',
        },
        validationSchema: Yup.object({
            "season_start": Yup.string(),
            "season_end": Yup.string(),
            "season_name": Yup.string(),
        }),
        onSubmit: (values) => {
            const data = new FormData()
            data.append('society_id', society_id)
            data.append('start_date', values.season_start)
            data.append('end_date', values.season_end)
            data.append('account_name', values.season_name)
            data.append('season_id', season_id?season_id:0)
  
            api.post('/account/new/prod/account', data,{
                headers: {
                    Authorization:'Bearer ' + fetchToken(),
                },
            }).then(function (response){
                toast.success(response.data);
                fetch_seasons();
                handleCloseSetup();
                setSeason_id(null);
            }).catch(function (error){
                console.log(error);
            })
        }
    });

      function formatDateToYearMonthDay(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = 'th';
      
        if (day === 1 || day === 21 || day === 31) {
          suffix = 'st';
        } else if (day === 2 || day === 22) {
          suffix = 'nd';
        } else if (day === 3 || day === 23) {
          suffix = 'rd';
        }
      
        return `${day}${suffix} ${month} ${year}`;
      }
      
      const isToday = (someDate) => {
        const today = new Date();
        return someDate.getDate() === today.getDate() &&
               someDate.getMonth() === today.getMonth() &&
               someDate.getFullYear() === today.getFullYear();
      };
      
      const renderTitle = (name, date) => {
        const formattedDate = formatDateToYearMonthDay(date);
        return (
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>{name} : {formattedDate}</b>
            {isToday(date) && <Chip variant='outlined' size='small' sx={{ m:1 }} color='success' label="today" />}
          </Typography>
        );
      };

      useEffect(() => {
        fetch_seasons();
      },[])



    
    return (
                <div className="app">
                    <div className="content">
                        <Box sx={{m:5}}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                              <Header title="Farming Seasons"  subtitle={society} />
                            </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h4' sx={{ textAlign:'center', m:1 }}>
                                    <b>{(typeof society === 'string' && society.includes('Society' || 'society')) ? society : `${society} Society`}</b>
                                </Typography>
                                <Button  
                                    size='small' 
                                    sx={{ m:1, 
                                            borderRadius:4,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                            minWidth: 0,
                                            '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#80ed99',
                                            color:'#000'
                                            },
                                        }} 
                                    variant='contained' 
                                    onClick={NewSeason}
                                    
                                >
                                    New Season
                                </Button>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                {
                                !big_loading && seasons[0]?
                                <Box sx={{ display:'flex', width:1130, marginBottom:20, flexWrap:'wrap', maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                        width: '7px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                }}}>
                                    
                                        {
                                        seasons.map((one) => (
                                            <Card sx={{ m:1, width:350}}>
                                                <CardHeader
                                                    title={<Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{one.season_name}</b></Typography>}
                                                />
                                                <CardContent>
                                                <Box sx={{ display: 'block', justifyContent:'space-between' }}>
                                                    <>
                                                        {renderTitle('Start date',new Date(one.start_date))}
                                                        {one.end_date? renderTitle('End date', new Date(one.end_date)): (<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>End date: N/A</b></Typography>)}
                                                    </>
                                                    <>
                                                    <Chip
                                                        variant="outlined"
                                                        onClick={() => UpdateSeason(one.start_date, one.end_date, one.season_name, one.id)}
                                                        label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Update</b></Typography>}
                                                        sx={{
                                                          color:'#000',
                                                          backgroundColor: "#eb5e28",
                                                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                          minWidth: 0,
                                                          '&:hover': {
                                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                            backgroundColor:'#bc6c25',
                                                            color:'#fff',
                                                          },
                                                        }} 
                                                        size='small'
                                                    />
                                                    </>
                                                </Box>
                                                <Box sx={{ mt:2, display:'flex', justifyContent:'space-between' }}>
                                                <Box sx={{ m:'5px' }}>
                                                    <IconButton><OpenInNew /></IconButton> 
                                                </Box>
                                                   <div style={{ marginLeft:'auto' }}>
                                                    {
                                                    one.status === 'Not Started'?
                                                    <Chip
                                                        color="warning"
                                                        variant="outlined"
                                                        label={one.status}
                                                        sx={{
                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                        minWidth: 0,
                                                        }} 
                                                        size='small'
                                                    />
                                                    :one.status === "Ongoing"
                                                    ? <Chip
                                                        color="success"
                                                        label={one.status}
                                                        sx={{
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                            minWidth: 0
                                                        }} 
                                                        size='small'
                                                    />
                                                    :one.status === "Ended"
                                                    ?<Chip
                                                        color="action"
                                                        label={one.status}
                                                        sx={{
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                            minWidth: 0
                                                        }} 
                                                        size='small'
                                                    />

                                                    :null
                                                    }
                                                    </div>
                                                </Box>
                                                </CardContent>
                                            </Card>
                                        ))
                                        }
                                </Box>
                                : big_loading && !seasons[0]?
                                <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'>
                                    <b>Fetching Seasons...</b>
                                </Typography>
                                : 
                                <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='body2'>
                                    <b>No Seasons Established</b>
                                </Typography>
                            }
                            </Grid>
                        </Grid>
                        
                            
                        <Modal
                          open={open_modal}
                          onClose={handleCloseSetup}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box sx={style}>
                            <Grid  container spacing={1}>
                              <Grid item xs={12} md={12}>
                                <Typography sx={{ textAlign:'center' }} variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>
                                      {season_id?'Update Season':'New season for production loans'} 
                                  </b>
                                </Typography>
                                {
                                  season_id?
                                  null
                                  :
                                    <Typography sx={{ color:'#001d3d', m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>
                                        Production loans are activated during farming seasons. 
                                        Please establish a season and proceed with your loan requests. 
                                        <br/>(NB: end of season can be specified later) 
                                      </b>
                                    </Typography>
                                }
                                
                              </Grid>
                              {/* <form onSubmit={formik.handleSubmit}> */}
                              <Grid item xs={12} md={12} sx={{ m:1, display:'flex' }}>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Season Start Date:
                                    </b>
                                  </Typography>
                                  <TextField
                                    size='small'
                                    fullWidth
                                    name='season_start'
                                    type='date'
                                    value={formik.values.season_start}
                                    onChange={formik.handleChange}
                                    variant="standard"
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.season_start && Boolean(formik.errors.season_start)}
                                    helperText={formik.touched.season_start && formik.errors.season_start}
                                  />
                                </Grid>

                                <Grid item xs={12} md={12} sx={{ m:1, display:'flex' }}>
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Season End Date (Optional):
                                    </b>
                                  </Typography>
                                  <TextField
                                      size='small'
                                      fullWidth
                                      name='season_end'
                                      type='date'
                                      value={formik.values.season_end}
                                      onChange={formik.handleChange}
                                      variant="standard"
                                      onBlur={formik.handleBlur}
                                      error={formik.touched.season_end && Boolean(formik.errors.season_end)}
                                      helperText={formik.touched.season_end && formik.errors.season_end}
                                    />
                                </Grid>

                                <Grid item xs={12} md={12} sx={{ m:1 }}>
                                  <TextField
                                      size='small'
                                      fullWidth
                                      name='season_name'
                                      label="Season Name (Optional)"
                                      value={formik.values.season_name}
                                      onChange={formik.handleChange}
                                      variant="standard"
                                      onBlur={formik.handleBlur}
                                      error={formik.touched.season_name && Boolean(formik.errors.season_name)}
                                      helperText={formik.touched.season_name && formik.errors.season_name}
                                    />
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      Season name will be generated automatically if field is left empty.
                                    </b>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Button 
                                    size='small'
                                    variant='contained' 
                                    sx={{ 
                                      m:1, 
                                      backgroundColor:'#6e1423', 
                                      borderRadius:4, 
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#80ed99',
                                        color:'#000'
                                      },
                                    }} 
                                    onClick={handleCloseSetup}
                                  >
                                    Cancel
                                  </Button>

                                  <Button 
                                    size='small'
                                    variant='contained' 
                                    sx={{ 
                                      m:1, 
                                      borderRadius:4, 
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#80ed99',
                                        color:'#000'
                                      },
                                    }} 
                                    color='success'
                                    onClick={formik.handleSubmit}
                                  >
                                    Save
                                  </Button>
                                </Grid>
                              {/* </form> */}
                            </Grid>
                          </Box>
                        </Modal>
                      </Box>
                    </div>
                </div>
    )
}

export default Season;